import { Box } from '@mui/material';
import React from 'react';
import CustomButton from '../../../../../components/Buttons/CustomButton';

export function ClearButton({ onClick, title = 'Сбросить параметры' }) {
  return (
    <Box>
      <CustomButton variant="text" onClick={onClick}>{title}</CustomButton>
    </Box>
  );
}
